import { useCallback, useEffect, useState } from 'react';

import { copyText } from '../../../utils/copyText';

export interface ICopyClickData {
  isCopied: boolean;
  handleCopy: (text: string) => void;
}

const TIMEOUT = 1_500;

export const useCopyClick = (): ICopyClickData => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback((text: string) => {
    copyText(text);
    setIsCopied(true);
  }, []);

  useEffect(() => {
    if (!isCopied) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      setIsCopied(false);
    }, TIMEOUT);

    return () => clearTimeout(timeoutId);
  }, [isCopied]);

  return { isCopied, handleCopy };
};
